module.exports = __webpack_public_path__ + "img/france.823dd4b3.svg";